import React from 'react';
import './a5_print_style.scss';
import companyLogo from 'assets/img/images/print_logo.png';
import Barcode from 'react-barcode';
import moment from 'moment';
import { moneyDecimalFormatter, customRound } from 'utli';

class A5ENPrintComponent extends React.Component {
  render() {
    const { data } = this.props;

    if (!data) return null;

    return (
      <div className={'Finance-Print'}>
        <div className={'Container'}>
          <div className={'LeftContainer'}>
            {/** Left Side */}
            <div className={'ContainerHeader'}>
              <div className={'Container'}>
                {/** Logo and Barcode */}
                <div className={'LogoContainer'}>
                  <img className={'Logo'} src={companyLogo} alt='Company Logo' style={{ width: 240, height: 80 }} />
                </div>
                <div className='BarCodeContainer'>
                  <h2>INVOICE</h2>
                  <Barcode
                    fontOptions='bolder'
                    value={data?.invoice_number}
                    width={2}
                    height={50}
                    fontSize={34}
                    margin={3}
                  />
                </div>
              </div>

              <div className='CodesContainer'>
                <h4>Customer code: {data.address_code}</h4>
                <h4>Salesperson code: {data.sale_person?.name}</h4>
              </div>
            </div>
            <div className={'ContainerItem'}>
              <div className={'Container'}>
                {/**container */}
                <h4 className={'Header'}>
                  {/**header */}
                  Shipper Information
                </h4>
                <h4 className={'Header'}>
                  {/**header */}
                  Consignee Information
                </h4>
              </div>
              {/* <div className={'Divider'} /> */}
              <div className={'Container'}>
                {/**container */}
                <div className={'Item'}>
                  <p>{data?.sender?.company}</p>
                  <p>{data?.sender?.name}</p>
                  <p>{data?.sender?.phone}</p>
                  <p>{data?.sender?.address}</p>
                </div>
                <div className={'Item'}>
                  <p>{data?.receiver?.company}</p>
                  <p>{data?.receiver?.name}</p>
                  <p>{data?.receiver?.phone}</p>
                  <p>{data?.receiver?.address}</p>
                </div>
              </div>
            </div>
            <div className={'ContainerItem'}>
              <div className={'Container'}>
                {/**container */}
                <h4 className={'Header'}>
                  {/**header */}
                  Basic Information
                </h4>
              </div>
              {/* <div className={'Divider'} /> */}
              <div className={'Container'}>
                {/**container */}
                <div className={'Item'}>
                  <p>Invoice Date: {moment(Date.parse(data?.invoice_date)).format('DD-MM-YYYY')}</p>
                  <p>Ref No: {data?.ref_no || '-'}</p>
                  <p>License No: {data?.license_no || '-'}</p>
                  <p>Invoice No: {data?.invoice_number || '-'}</p>
                </div>
                <div className={'Item'}>
                  <p>Destination Branch: {data?.destination?.name}</p>
                  <p>Payment Method: {data?.paymentType?.name}</p>
                  <p>Deposit Invoice: {data?.deposit_invoice?.invoice_number || '-'}</p>
                </div>
              </div>
            </div>
            <div className={'ContainerItem'}>
              <div className={'Container'}>
                {/**container */}
                <h4 className={'Header'}>
                  {/**header */}
                  Cargo Information
                </h4>
              </div>
              {/* <div className={'Divider'} /> */}
              <div className={'Container'}>
                {/**container */}
                <div className={'Item'} style={{ width: '100%' }}>
                  {data?.items?.map((item, index) => (
                    <p key={index}>
                      {index + 1}. {item.itemname} ({item.qty} {item.unit}) - {moneyDecimalFormatter(item.amount)}
                    </p>
                  ))}
                </div>
              </div>
            </div>
            <div className={'ContainerItem'}>
              <div className={'Container'}>
                {/**container */}
                <h4 className={'Item'}>
                  {/**header */}
                  Cost Information
                </h4>
                <h4 className={'Item'}>Payment method: {data?.paymentType?.name}</h4>
              </div>
              <div className={'Divider'} />
            </div>
            {/* <div className={'Divider'} /> */}
            <div className={'FooterContainer'}>
              <div>
                <h4>Total Charges ({data?.currency})</h4>
                <h4>Other Service Charges</h4>
                <h4>Received Amount</h4>
                <h4>Remaining Balance</h4>
              </div>
              <div className={'DividerRow'}>
                <h4>:</h4>
                <h4>:</h4>
                <h4>:</h4>
                <h4>:</h4>
              </div>
              <div>
                <h4>{moneyDecimalFormatter(customRound(data?.total_amount?.toFixed(2)))}</h4>
                <h4>{moneyDecimalFormatter(customRound(data?.other_service_charges?.toFixed(2)))}</h4>
                <h4>{moneyDecimalFormatter(customRound(data?.received_amount?.toFixed(2)))}</h4>
                <h4>{moneyDecimalFormatter(customRound(data?.remaining_balance?.toFixed(2)))}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default A5ENPrintComponent;
